(function ($) {
	$.fn.extend({
		vakinnform: function (options) {
			var defaults = {
				beforeSubmit: null,
				afterSuccess: null,
				allowRedirect:true,
				showSplash: false,
				splashText : 'Augnablik...'
			};

			var o = $.extend(defaults, options);

			return this.each(function () {
				var $vakinnForm = $(this);
				var $dialog = null;
				if(o.showSplash) {
					$dialog = $('<div>' + o.splashText + '</div>').dialog({
						modal : true,
						dialogClass : 'splash',
						autoOpen: false
					});
				}

				$vakinnForm.ajaxForm({
					dataType: 'json',
					beforeSubmit: function (formData, jqForm, options) {
						// Disable sumit buttons
						var $submit = $vakinnForm.find(':submit')
						$submit.attr('disabled', 'disabled');
						// Show splash
						if(o.showSplash && !$submit.hasClass('skipSplash')) {
							$dialog.dialog('open');
						}
					},
					success: function (responseText, statusText, xhr, $form) {
						var r = responseText;
						$vakinnForm.find(':submit').removeAttr('disabled');
						// Success
						if (r.status == 'success') {

							if (r.url != '' && o.allowRedirect) {
								window.location = r.url;
								return true;
							}
							if (o.afterSuccess && o.afterSuccess(this, responseText) === false) {
								return this;
							}
							if(o.showSplash) {
								$dialog.dialog('close');
							}
							return false;
						}
						else if (r.status == 'error') {
							// $dialog.dialog('close');
							$vakinnForm.find('ul.errors').remove();
							$vakinnForm.find('div.message').remove();
							$.each(r.formMessages, function (field, error) {
								var $field = $('#' + field);
								var errorStr = '<ul class="errors">';
								$.each(error, function (i, errorMsg) {
									errorStr += '<li>' + errorMsg + '</li>';
								});
								errorStr += '</ul>';
								$field.after(errorStr);
							});
							$vakinnForm.find('ul.errors').effect("highlight", {}, 1000);
						}
						$vakinnForm.find(':submit').removeAttr('disabled');
						if(o.showSplash) {
							$dialog.dialog('close');
						}

						return false;
					}
				});
			});
		}
	});
})(jQuery);